export default __webpack_public_path__ + "static/media/ger1.5c3cbf97.jpeg";